import React from "react";
import { useToast } from "../../components/showtoast/ToastContext.jsx";
import { BarWaveSpinner, BlobMorphSpinner, CircleSpinnerIcon, DotOrbitSpinner, DualRingSpinner, DualRotationOrbitSpinner, MultiOrbitSpinner, MultiOrbitSpinner2, MultiOrbitSpinner3, SingleOrbitSpinner, ThreeDotsBounceSpinner, TrailArcSpinner } from "../../lib/myIcons.jsx";

function TestToast() {
  const { showToast, closeToast } = useToast();

  // Programmatic close example
  const handleProgrammaticClose = () => {
    const id = showToast("This will close in 3 seconds by code", "alert", 15000);

    setTimeout(() => {
      closeToast(id);
    }, 3000);
  };


  const handleEmail=()=>{

  }


  return (
    <div style={{ padding: "20px" }}>
      <h2>Toast Testing</h2>

      <button
        onClick={() => showToast("This is an info toast", "info", 5000)}
        style={{ margin: "5px" }}
      >
        Show Info
      </button>

      <button
        onClick={() => showToast("This is an alert toast", "alert", 5000)}
        style={{ margin: "5px" }}
      >
        Show Alert
      </button>

      <button
        onClick={() => showToast("This is a delete toast", "delete", 5000)}
        style={{ margin: "5px" }}
      >
        Show Delete
      </button>

      <button
        onClick={() => showToast("This is an error toast", "error", 5000)}
        style={{ margin: "5px" }}
      >
        Show Error
      </button>

      <button
        onClick={() => showToast("This is a success toast", "success", 5000)}
        style={{ margin: "5px" }}
      >
        Show Success
      </button>

      <button
        onClick={() =>

          showToast("This toast lasts 10 seconds", "info", 10000)
        }
        style={{ margin: "5px" }}
      >
        Show 10 sec Toast
      </button>

      <button
        onClick={handleProgrammaticClose}
        style={{ margin: "5px" }}
      >
        Programmatic Close in 3 sec
      </button>


      <CircleSpinnerIcon></CircleSpinnerIcon>
      <DualRingSpinner></DualRingSpinner>
        <DotOrbitSpinner></DotOrbitSpinner>
        <TrailArcSpinner></TrailArcSpinner>
      <ThreeDotsBounceSpinner></ThreeDotsBounceSpinner>
      <BarWaveSpinner></BarWaveSpinner>
      <BlobMorphSpinner></BlobMorphSpinner>

      <SingleOrbitSpinner></SingleOrbitSpinner>
      <MultiOrbitSpinner></MultiOrbitSpinner>
      <DualRotationOrbitSpinner></DualRotationOrbitSpinner>
      <MultiOrbitSpinner2></MultiOrbitSpinner2>
      <MultiOrbitSpinner3></MultiOrbitSpinner3>


        <button onClick={handleEmail}>Send Test Email</button>

    </div>
  );
}

export default TestToast;
